// extracted by mini-css-extract-plugin
export default {"modal":"_0aYKV0G1--ModalKitModal_modal__Nzo9Z","wiggle":"_0aYKV0G1--ModalKitModal_wiggle__B+IBT","shimmer":"_0aYKV0G1--ModalKitModal_shimmer__1nsOX"};